import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface Props {
  children: React.ReactNode
}

const DescriptionBox = ({ children }: Props) => (
  <Box
    background="grey200"
    borderRadius={{
      all: 'abs008',
    }}
    width="full"
    padding="s24"
    gap="s16"
  >
    {children}
  </Box>
)

export default DescriptionBox
